// Mock content for SLA landing + admin. All data here is purely frontend-only and NOT loaded from backend yet.

export const SUPPORTED_LANGUAGES = ["en", "ua"];

export const NAV_ITEMS = [
  { id: "who-we-are", anchor: "who-we-are", label: { en: "Who we are", ua: "Хто ми" } },
  { id: "what-we-do", anchor: "what-we-do", label: { en: "What we do", ua: "Що ми робимо" } },
  { id: "news", anchor: "news", label: { en: "News", ua: "Новини" } },
  { id: "contacts", anchor: "contacts", label: { en: "Contacts", ua: "Контакти" } },
];

export const HERO_CONTENT = {
  en: {
    title: "Strategic Influence. Transparent Impact.",
    ctaLabel: "Learn more",
    ctaHref: "#who-we-are",
  },
  ua: {
    title: "Strategic Influence. Transparent Impact.",
    ctaLabel: "Дізнатися більше",
    ctaHref: "#who-we-are",
  },
};

export const ABOUT_CONTENT = {
  en: {
    title: "Who we are",
    body: [
      "Strategic Lobbying Alliance is an independent, non-partisan organization committed to advancing transparent, ethical, and effective lobbying practices across jurisdictions.",
      "Operating across the United States, the European Union, and emerging markets, SLA unites corporations, advocacy professionals, and policy experts to foster responsible lobbying and accountable governance.",
    ],
    buttonLabel: "More about SLA",
    buttonHref: "#what-we-do",
    imageAlt: "Strategic lobbying discussion in an international setting",
    imageUrl:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80",
  },
  ua: {
    title: "Хто ми",
    body: [
      "Strategic Lobbying Alliance — незалежна, позапартійна організація, що просуває прозорі, етичні та ефективні лобістські практики.",
      "Працюючи у США, ЄС та країнах, що розвиваються, SLA об'єднує корпорації, лобістів і експертів з публічної політики для підвищення підзвітності влади.",
    ],
    buttonLabel: "Більше про SLA",
    buttonHref: "#what-we-do",
    imageAlt: "Стратегічне обговорення лобізму на міжнародному рівні",
    imageUrl:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80",
  },
};

export const WHAT_WE_DO_INTRO = {
  en: {
    title: "What we do",
    paragraphs: [
      "SLA stands at the intersection of public policy, international relations, and strategic communications.",
      "With operational presence in the United States, the European Union, and Eastern Europe, SLA provides professional representation of clients’ interests across governments, multilateral institutions, and media platforms.",
    ],
  },
  ua: {
    title: "Що ми робимо",
    paragraphs: [
      "SLA працює на перетині публічної політики, міжнародних відносин і стратегічних комунікацій.",
      "Маючи операційну присутність у США, ЄС та Східній Європі, SLA професійно представляє інтереси клієнтів перед урядами, міжнародними інституціями та медіа.",
    ],
  },
};

export const WHAT_WE_DO_SLIDES = [
  {
    id: "key-pillars",
    order: 1,
    title: { en: "Key Pillars", ua: "Ключові засади" },
    intro: {
      en: "The Alliance combines American lobbying standards with European transparency principles and local expertise.",
      ua: "Альянс поєднує американські стандарти лобізму з європейськими принципами прозорості та місцевою експертизою.",
    },
    bullets: {
      en: [
        "Strategic Lobbying & Government Relations – representation of interests in the US, EU, and Ukraine.",
        "Public Affairs & Global Communications – international communication, media relations, reputation campaigns.",
        "Policy & Regulatory Advisory – analytics, compliance, and political process forecasting.",
        "Advocacy & Coalition Building – partnerships between business, civil society, and governments.",
        "Ethics & Transparency – compliance with international standards of integrity in lobbying.",
      ],
      ua: [
        "Strategic Lobbying & Government Relations — представництво інтересів у США, ЄС та Україні.",
        "Public Affairs & Global Communications — міжнародні комунікації, робота зі ЗМІ, репутаційні кампанії.",
        "Policy & Regulatory Advisory — аналітика, комплаєнс та прогнозування політичних процесів.",
        "Advocacy & Coalition Building — партнерства між бізнесом, громадськістю та урядами.",
        "Ethics & Transparency — дотримання міжнародних стандартів доброчесності у лобізмі.",
      ],
    },
    imageUrl:
      "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "support-services",
    order: 2,
    title: { en: "Support Services", ua: "Супровідні послуги" },
    intro: {
      en: "Comprehensive support for market entry, compliance and day-to-day operations.",
      ua: "Комплексний супровід виходу на ринок, комплаєнсу та щоденної діяльності.",
    },
    bullets: {
      en: [
        "Analysis of the market and legislation in the relevant field.",
        "Advisory on organisation, management and regulation of business in Ukraine.",
        "Preparation of commercial proposals and step-by-step action plans.",
        "Establishment of a legal entity with the most advantageous structure.",
        "Obtaining licences and permits required for operations.",
        "Drafting proposals to optimise legislation in the client’s interest.",
        "Full legal support with authorities and counterparties.",
        "Protection of the client’s interests before regulators, authorities and courts.",
      ],
      ua: [
        "Аналіз ринку та законодавства у відповідній сфері.",
        "Консультації щодо організації, управління та регулювання бізнесу в Україні.",
        "Підготовка комерційних пропозицій і покрокових планів дій.",
        "Створення юридичної особи з оптимальною організаційно-правовою формою.",
        "Отримання ліцензій та інших необхідних дозволів.",
        "Підготовка пропозицій щодо оптимізації законодавства в інтересах Клієнта.",
        "Повний юридичний супровід у відносинах з органами влади та контрагентами.",
        "Захист інтересів Клієнта у регуляторних органах, органах влади та судах.",
      ],
    },
    imageUrl:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "lobbying-services",
    order: 3,
    title: { en: "Lobbying Services", ua: "Лобістські послуги" },
    intro: {
      en: "We create exceptional opportunities for lobbying as an essential and ethical instrument for democratic decision-making and international partnership.",
      ua: "Ми створюємо виняткові можливості для лобізму як необхідного й етичного інструменту демократичного врядування та міжнародного партнерства.",
    },
    bullets: {
      en: [
        "Direct and indirect communication with lobbying targets.",
        "Preparation and dissemination of analytical and policy materials.",
        "Participation in public events, conferences and forums.",
        "Inviting public officials and decision-makers to thematic events.",
        "Design and implementation of advocacy and awareness campaigns.",
        "Development of communication strategies and media relations.",
        "Representation in international and regional media and expert communities.",
        "Crisis communications and reputation protection.",
        "Preparation of public statements, media materials and press kits.",
      ],
      ua: [
        "Прямі та опосередковані комунікації з адресатами лобіювання.",
        "Підготовка та поширення аналітичних матеріалів і policy paper.",
        "Участь у публічних заходах, конференціях і форумах.",
        "Запрошення посадовців та ухвалювачів рішень на тематичні події.",
        "Організація та проведення адвокаційних і інформаційних кампаній.",
        "Розробка комунікаційних стратегій та взаємодія зі ЗМІ.",
        "Представництво інтересів у міжнародних та регіональних медіа й експертних спільнотах.",
        "Антикризові комунікації та захист репутації.",
        "Підготовка публічних заяв, медіаматеріалів та прес-китів.",
      ],
    },
    cta: {
      en: "Learn more about lobbying services",
      ua: "Дізнатися більше про лобістські послуги",
      href: "#contacts",
    },
    imageUrl:
      "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=900&q=80",
  },
];

export const INITIAL_NEWS = [
  {
    id: "1",
    imageUrl:
      "https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=700&q=80",
    publishedAt: "2025-06-04",
    tags: ["Policy", "EU", "Ukraine"],
    isPublished: true,
    title: {
      en: "SLA launches transatlantic initiative on ethical lobbying standards",
      ua: "SLA запускає трансатлантичну ініціативу зі стандартів етичного лобізму",
    },
    summary: {
      en: "The Alliance brings together policymakers and business leaders from the US, EU and Eastern Europe to harmonise transparency rules.",
      ua: "Альянс об’єднує політиків та бізнес із США, ЄС та Східної Європи для узгодження правил прозорості.",
    },
  },
  {
    id: "2",
    imageUrl:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=700&q=80",
    publishedAt: "2025-05-20",
    tags: ["Conference", "Washington, D.C."],
    isPublished: true,
    title: {
      en: "Strategic Dialogue on Responsible Lobbying in Emerging Markets",
      ua: "Стратегічний діалог щодо відповідального лобізму на ринках, що розвиваються",
    },
    summary: {
      en: "SLA convened a high-level roundtable to discuss safeguards and best practices for lobbying in emerging democracies.",
      ua: "SLA провів круглий стіл високого рівня щодо запобіжників та кращих практик лобізму в країнах, що розвиваються.",
    },
  },
  {
    id: "3",
    imageUrl: null,
    publishedAt: "2025-04-02",
    tags: ["Insight", "Regulation"],
    isPublished: true,
    title: {
      en: "Briefing: New transparency requirements for EU interest representatives",
      ua: "Аналітика: нові вимоги прозорості для лобістів у ЄС",
    },
    summary: {
      en: "SLA experts outline how updated EU frameworks will affect cross-border advocacy and compliance.",
      ua: "Експерти SLA пояснюють, як оновлені рамки ЄС вплинуть на міжнародну адвокацію та комплаєнс.",
    },
  },
];

export const CONTACTS = {
  email: "info@sla-lobbying.com",
  phone: "+38 (077) 777 02 59",
  address: {
    en: "2, Khrestovyi alley, 5th floor, Kyiv, 01010, Ukraine",
    ua: "пров. Хрестовий, 2, 5-й поверх, Київ, 01010, Україна",
  },
  linkedin: {
    label: {
      en: "Follow SLA on LinkedIn",
      ua: "Слідкуйте за SLA в LinkedIn",
    },
    url: "https://www.linkedin.com",
  },
  copyright: {
    en: "All Rights Reserved",
    ua: "Усі права захищено",
  },
};

export const SITE_META = {
  en: {
    title: "Strategic Lobbying Alliance",
    description:
      "Strategic Lobbying Alliance (SLA) – global platform for transparent, ethical and effective lobbying.",
  },
  ua: {
    title: "Strategic Lobbying Alliance",
    description:
      "Strategic Lobbying Alliance (SLA) – глобальна платформа прозорого, етичного та ефективного лобізму.",
  },
};
